import { render, staticRenderFns } from "./AddRequestComment.vue?vue&type=template&id=c07c26b0&scoped=true&"
import script from "./AddRequestComment.vue?vue&type=script&lang=js&"
export * from "./AddRequestComment.vue?vue&type=script&lang=js&"
import style0 from "./AddRequestComment.vue?vue&type=style&index=0&id=c07c26b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07c26b0",
  null
  
)

component.options.__file = "AddRequestComment.vue"
export default component.exports